"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

require("./Checkbox.css");

var icons_1 = require("@tiendanube/icons");

function Checkbox(_a) {
  var name = _a.name,
      label = _a.label,
      _b = _a.checked,
      checked = _b === void 0 ? false : _b,
      _c = _a.disabled,
      disabled = _c === void 0 ? false : _c,
      onChange = _a.onChange;

  var handleClickDiv = function handleClickDiv(event) {
    event.stopPropagation();
  };

  var handleChange = function handleChange(event) {
    var target = event.target;
    onChange === null || onChange === void 0 ? void 0 : onChange({
      name: target.name,
      checked: target.checked
    });
  };

  var renderChecked = checked && React.createElement("div", {
    className: "nimbus--checkbox__check"
  }, React.createElement(icons_1.CheckIcon, null));
  var isIndeterminate = checked === "indeterminate";
  var isChecked = !isIndeterminate && Boolean(checked);
  var inputRef = React.useRef(null);
  React.useEffect(function () {
    var _a;

    if (!isChecked) (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.blur();
  }, [isChecked]);
  return React.createElement("div", {
    className: "nimbus--checkbox-wrapper",
    onClick: handleClickDiv
  }, React.createElement("input", {
    type: "checkbox",
    id: "check_" + name,
    ref: inputRef,
    name: name,
    onChange: handleChange,
    value: name,
    className: "nimbus--checkbox " + (isIndeterminate ? "indeterminate" : ""),
    checked: isChecked,
    disabled: disabled
  }), React.createElement("label", {
    htmlFor: "check_" + name,
    className: "nimbus--checkbox-label " + (!label ? "nimbus--label-hidden" : "")
  }, React.createElement("span", {
    className: "nimbus--text"
  }, label)), renderChecked);
}

var Skeleton = function Skeleton() {
  return React.createElement("div", {
    className: "nimbus--checkbox-skeleton"
  });
};

Checkbox.Skeleton = Skeleton;
exports.default = Checkbox;